<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="编辑车辆" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="625px">
    <div class="dialog__container">
      <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
        label-width="70px">
        <el-form-item label="车辆名称：" prop="name" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="车牌号：" prop="costAmount" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.car" placeholder="请输入车牌号" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.remark" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {
    saveCar,
  } from '@/api/Car'
  import cookies from '../../../libs/util.cookies'
  export default {
    data() {
      return {
        form: {
          name: '',
          car: ''
        },
        rules: {
          name: [{
            required: true,
            message: "请输入名称",
            trigger: "blur",
          }, ],
          car: [{
            required: true,
            message: "请输入车牌",
            trigger: "blur",
          }, ]
        },
        loadBtn: false,
      };
    },
    props: {
      detail: {
        required: true,
        type: Object
      }
    },
    created() {
      this.form = {
        ...this.detail
      }
    },
    methods: {
      handleBeforeClose(done) {
        this.$emit("cancel");
        done();
      },
      handleCancel() {
        this.$emit("cancel");
      },
      async handleConfirm() {
        if (this.loadBtn) return;
        this.$refs["form"].validate(async (valid) => {

          if (valid) {
            this.loadBtn = true;
            const params = {
              ...this.form
            }
            const res = await saveCar(params);
            if (res.code === 200) {
              this.$message.success("修改成功");
              this.$emit("confirm");
            }
            this.loadBtn = false;
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/CarManagement/components/EditCause.vue